import { FixMeLater } from '../temporary-types';
import PageNotFound from '../views/PageNotFound';
import GuardRegisterForm from '../utils/GuardRegisterForm';
import GuardApplicationSent from '../utils/GuardApplicationSent';

import Welcome from '../views/Welcome';
import Register from '../views/Register';
import buildPATHS, { loginPath } from '../utils/paths';
import ApplicationSent from '../views/ApplicationSent';
import Login from '../views/login/Login';
import AccountCreate from '../views/accounts/create/AccountCreate';
import MyAccounts from '../views/accounts/myAccounts/MyAccounts';
import ForgotPassword from '../views/accounts/forgot-password/ForgotPassword';
import MainTemplate from '../appTemplates/MainTemplate/MainTemplate';
import AccountEdit from '../views/accounts/edit/AccountEdit';
import MyRequests from '../views/requests/myRequests/MyRequests';
import MyForms from '../views/myForms/myForms';
import RequestDetails from '../views/requests/requestDetails/RequestDetails';
import AccountCreationSuccess from '../views/accounts/create/components/AccountCreationSuccess';

interface IRoute {
  path: string;
  component: React.FC | React.Component | FixMeLater;
  mainTemplate?: React.FC<any> | React.Component<any, any> | FixMeLater;
  guard?: React.FC<any> | React.Component<any, any> | FixMeLater;
  isProtected?: boolean;
}

const buildROUTES = (): IRoute[] => {
  const clearParams = (PATHS: Dict<string>): Dict<string> =>
    Object.entries(PATHS).reduce(
      (acc, [route, url]) => ({
        ...acc,
        [route]: url?.split('?')[0],
      }),
      {},
    );

  const PATHS_NO_PARAMS: Dict<string> = clearParams(buildPATHS());
  return [
    { path: PATHS_NO_PARAMS.login, component: Login },
    { path: PATHS_NO_PARAMS.welcome, component: Welcome },
    // { path: PATHS_NO_PARAMS.page_expired, component: PageExpired },

    {
      path: PATHS_NO_PARAMS.register,
      component: Register,
      guard: GuardRegisterForm,
    },

    {
      path: PATHS_NO_PARAMS.application_sent,
      component: ApplicationSent,
      guard: GuardApplicationSent,
    },
    { path: PATHS_NO_PARAMS.account_register, component: AccountCreate },
    {
      path: PATHS_NO_PARAMS.project_account_register,
      component: AccountCreate,
    },

    {
      path: PATHS_NO_PARAMS.account_register_success,
      component: AccountCreationSuccess,
    },

    {
      path: PATHS_NO_PARAMS.my_accounts,
      isProtected: true,
      component: MyAccounts,
      mainTemplate: MainTemplate,
    },
    { path: PATHS_NO_PARAMS.forgot_password, component: ForgotPassword },
    {
      path: PATHS_NO_PARAMS.account_edit,
      component: AccountEdit,
      mainTemplate: MainTemplate,
      isProtected: true,
    },
    {
      path: PATHS_NO_PARAMS.my_requests,
      component: MyRequests,
      mainTemplate: MainTemplate,
      isProtected: true,
    },
    {
      path: PATHS_NO_PARAMS.my_forms,
      component: MyForms,
      mainTemplate: MainTemplate,
      isProtected: true,
    },
    {
      path: PATHS_NO_PARAMS.request_details,
      component: RequestDetails,
      mainTemplate: MainTemplate,
      isProtected: true,
    },
    { path: '*', component: PageNotFound },
  ];
};

export default buildROUTES;
